// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-transition-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--auth-transition-bg, #ffffff);
  font-family: 'Lato', sans-serif;
  opacity: 0;
  visibility: visible;
  transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1),
    visibility 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.auth-transition-overlay.is-entered {
  opacity: 1;
}

:root[data-theme='dark'] .auth-transition-overlay {
  background: var(--auth-transition-bg-dark, #18212f);
  color-scheme: dark;
}

.auth-transition-overlay.fade-out {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.auth-transition-logo {
  /* Mismo tamaño que boot HTML / splash nativo (león solo), no 250px del wordmark.
     Visible con el overlay (sin fade propio) para no mostrar barra sola un instante. */
  display: block;
  max-width: 148px;
  width: min(148px, 40vw);
  height: auto;
  object-fit: contain;
}

.auth-transition-logo svg {
  display: block;
  width: 100%;
  height: auto;
}

.auth-transition-bar {
  width: min(250px, 58vw);
  height: 6px;
  margin-top: 1.5rem;
  overflow: hidden;
  background: var(--auth-transition-bar-track, #f3f8ff);
  border-radius: 10px;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

:root[data-theme='dark'] .auth-transition-bar {
  background: var(--auth-transition-bar-track-dark, #1d2736);
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.35);
}

/* Visual: slide indeterminado (mismo dialecto que boot HTML).
   El progreso monotónico en sessionStorage sigue para show/hide/TTL/clear. */
.auth-transition-progress {
  height: 100%;
  border-radius: inherit;
  background: var(--auth-transition-bar-fill, #cd9a62);
  width: 40%;
  animation: auth-transition-slide 1.1s ease-in-out infinite;
}

@keyframes auth-transition-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .auth-transition-overlay {
    transition: none;
    opacity: 1;
  }

  .auth-transition-progress {
    animation: none;
    width: 55%;
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./packages/auth-transition/src/auth-transition.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,8CAA8C;EAC9C,+BAA+B;EAC/B,UAAU;EACV,mBAAmB;EACnB;mDACiD;AACnD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;uFACqF;EACrF,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,qDAAqD;EACrD,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,0DAA0D;EAC1D,+CAA+C;AACjD;;AAEA;6EAC6E;AAC7E;EACE,YAAY;EACZ,sBAAsB;EACtB,oDAAoD;EACpD,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".auth-transition-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--auth-transition-bg, #ffffff);\n  font-family: 'Lato', sans-serif;\n  opacity: 0;\n  visibility: visible;\n  transition: opacity 0.4s cubic-bezier(0.22, 1, 0.36, 1),\n    visibility 0.45s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.auth-transition-overlay.is-entered {\n  opacity: 1;\n}\n\n:root[data-theme='dark'] .auth-transition-overlay {\n  background: var(--auth-transition-bg-dark, #18212f);\n  color-scheme: dark;\n}\n\n.auth-transition-overlay.fade-out {\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.auth-transition-logo {\n  /* Mismo tamaño que boot HTML / splash nativo (león solo), no 250px del wordmark.\n     Visible con el overlay (sin fade propio) para no mostrar barra sola un instante. */\n  display: block;\n  max-width: 148px;\n  width: min(148px, 40vw);\n  height: auto;\n  object-fit: contain;\n}\n\n.auth-transition-logo svg {\n  display: block;\n  width: 100%;\n  height: auto;\n}\n\n.auth-transition-bar {\n  width: min(250px, 58vw);\n  height: 6px;\n  margin-top: 1.5rem;\n  overflow: hidden;\n  background: var(--auth-transition-bar-track, #f3f8ff);\n  border-radius: 10px;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n:root[data-theme='dark'] .auth-transition-bar {\n  background: var(--auth-transition-bar-track-dark, #1d2736);\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.35);\n}\n\n/* Visual: slide indeterminado (mismo dialecto que boot HTML).\n   El progreso monotónico en sessionStorage sigue para show/hide/TTL/clear. */\n.auth-transition-progress {\n  height: 100%;\n  border-radius: inherit;\n  background: var(--auth-transition-bar-fill, #cd9a62);\n  width: 40%;\n  animation: auth-transition-slide 1.1s ease-in-out infinite;\n}\n\n@keyframes auth-transition-slide {\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(350%);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .auth-transition-overlay {\n    transition: none;\n    opacity: 1;\n  }\n\n  .auth-transition-progress {\n    animation: none;\n    width: 55%;\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
